module.exports = __webpack_public_path__ + "static/bg-afdbdb14b30dbf13cf5029cec2df4439.jpg";